
/**
 * Module dependencies.
 */

import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'
import {
  REQUEST_METADATAS,
  RECEIVE_METADATAS,
  FETCH_METADATAS_ERROR,
  REQUEST_METADATA_BY_SLUG,
  RECEIVE_METADATA_BY_SLUG,
  FETCH_METADATA_BY_SLUG_ERROR,
  INVALIDATE_METADATA_BY_SLUG,
  UPDATE_METADATA_BY_SLUG_ERROR,
  UPDATED_METADATA_BY_SLUG,
  CREATE_METADATA_ERROR,
  CREATED_METADATA
} from '../actions'

/**
 * Export our reducer.
 */

export default metadatasBySlug

const metadatasReducer = createApiMiddlewareReducer({
  request: REQUEST_METADATAS,
  failure: FETCH_METADATAS_ERROR,
  receive: RECEIVE_METADATAS
})

/**
 * Reduce `state` by `action`.
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 * @api public
 */

function metadatasBySlug (state = initialState(), action) {
  const { type, payload, error } = action
  switch (type) {
    case REQUEST_METADATAS:
    case RECEIVE_METADATAS:
    case FETCH_METADATAS_ERROR: {
      const slugifiedResponse = !payload.response ? null : toSlugMap(payload.response)
      return {
        ...state,
        [payload.metadataType]: metadatasReducer(state[payload.metadataType], {
          ...action,
          payload: {
            ...payload,
            response: slugifiedResponse
          }
        })
      }
    }
    case CREATE_METADATA_ERROR:
      return {
        ...state,
        [payload.metadataType]: {
          ...state[payload.metadataType],
          isRequesting: false,
          didRequestFail: true,
          error: (error || payload.error).toString()
        }
      }
    case CREATED_METADATA:
      return {
        ...state,
        [payload.metadataType]: {
          ...state[payload.metadataType],
          isRequesting: false,
          didRequestFail: false,
          error: false
        }
      }
    case REQUEST_METADATA_BY_SLUG:
    case RECEIVE_METADATA_BY_SLUG:
    case FETCH_METADATA_BY_SLUG_ERROR:
    case INVALIDATE_METADATA_BY_SLUG:
    case UPDATE_METADATA_BY_SLUG_ERROR:
    case UPDATED_METADATA_BY_SLUG:
      return {
        ...state,
        [payload.metadataType]: {
          ...state[payload.metadataType],
          data: {
            ...state[payload.metadataType].data,
            [payload.slug]: item(state, action)
          }
        }
      }

    default:
      return state
  }
}

/**
 * Individual metadata "item" reducer.
 */

function item (state, { type, payload }) {
  switch (type) {
    case REQUEST_METADATA_BY_SLUG:
      return {
        isRequesting: true,
        didRequestFail: false,
        didInvalidate: false,
        data: null
      }
    case RECEIVE_METADATA_BY_SLUG:
      return {
        isRequesting: false,
        didRequestFail: false,
        didInvalidate: false,
        data: payload.data
      }
    case FETCH_METADATA_BY_SLUG_ERROR:
      return {
        isRequesting: false,
        didRequestFail: true,
        didInvalidate: false,
        data: null
      }
    case INVALIDATE_METADATA_BY_SLUG:
      return {
        isRequesting: false,
        didRequestFail: false,
        didInvalidate: true,
        data: null
      }
    case UPDATED_METADATA_BY_SLUG:
      return {
        isRequesting: false,
        didRequestFail: false,
        didInvalidate: false,
        data: payload.data
      }
    case UPDATE_METADATA_BY_SLUG_ERROR:
      return {
        isRequesting: false,
        didRequestFail: true,
        didInvalidate: false,
        data: null
      }
    default:
      return state
  }
}

/**
 * Initial state.
 */

function initialState () {
  const types = [ 'source', 'integration', 'bitool', 'warehouse' ]
  const state = {}
  types.forEach(t => (state[t] = {
    isRequesting: false,
    didRequestFail: false,
    data: {}
  }))
  return state
}

/**
 * Map `array` by each item's slug.
 *
 * @param {Array} arr
 * @return {Object}
 * @api private
 */

function toSlugMap (arr) {
  const bySlug = {}
  for (let i = 0; i < arr.length; i++) {
    bySlug[arr[i].slug] = {
      isRequesting: false,
      didInvalidate: false,
      didRequestFail: false,
      data: arr[i]
    }
  }
  return bySlug
}



// WEBPACK FOOTER //
// ./reducers/metadata.js